export const australianStateOptions = [
  { label: "ACT", value: "act" },
  { label: "NSW", value: "nsw" },
  { label: "NT", value: "nt" },
  { label: "QLD", value: "qld" },
  { label: "SA", value: "sa" },
  { label: "TAS", value: "tas" },
  { label: "VIC", value: "vic" },
  { label: "WA", value: "wa" },
];

export const StateValues = {
  ACT: "act",
  NSW: "nsw",
  NT: "nt",
  QLD: "qld",
  SA: "sa",
  TAS: "tas",
  VIC: "vic",
  WA: "wa",
};
